// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import User from "./User";
// Constants
import { USER_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
import MessageContants from "../../../configs/MessageContants";
// Services
import { get, put } from "../../../services/FetchHelper";
import toast from 'react-hot-toast';
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import Filter from "./Filter";

const Users = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [users, setUsers] = useState({
        entries: [],
        total_count: 0
    });

    const getUsers = async () => {
        spinService.on();
        const params = new URLSearchParams({
            sort: filter.sort,
            order: filter.order,
            max: filter.max,
            offset: filter.offset + 1,
            search: filter.search,
            queryFilters: filter.queryFilters
        });

        const response = await get(EntityConstants.USERS, params);
        const data = await response.json();
        spinService.off();
        setUsers(data);
    };

    const onClose = () => {
        getUsers();
        setId(undefined);
        setOpen(false);
        setOpenFilter(false);

    };

    const onSwitch = async (e) => {
        spinService.on();
        const response = await put(EntityConstants.USERS + `/${e.id}`, { user: { status: !e.status } });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(MessageContants.USER_UPDATED);
            getUsers();
        }
        spinService.off();
    };

    useEffect(() => {
        if (permissions.has(PermissionConstants.USER_VIEW)) {
            getUsers();
        } else {
            navigate("/")
        }

    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Users
                    </Typography>
                    {permissions.has(PermissionConstants.USER_CREATE) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => { setId(undefined); setOpen(true) }}
                        >
                            New User
                        </Button>}
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={USER_TABLE_HEADS}
                        tableDatas={users.entries}
                        totalCount={users.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        onSwitch={(e) => onSwitch(e)}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.USER_VIEW) && open && <GoDrawer
                    title="User"
                    open={open}
                    onClose={() => onClose()}
                >
                    <User id={id} onClose={() => onClose()} />
                </GoDrawer>
            }
            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }
        </React.Fragment>
    );
}

export default Users;